import { db } from '@backend/db/db'
import { Box, Text } from '@chakra-ui/react'
import { getPatientStatementsCollectionPath, PatientStatement } from '@hb/shared'
import { useQuery } from '@hooks/backend/useQuery'
import { collection, CollectionReference, query, where } from 'firebase/firestore'
import { useMemo } from 'react'

export const PatientStatementsView = ({
  encounterId,
  patientId,
}: {
  encounterId: string
  patientId: string
}) => {
  const ref = useMemo(
    () =>
      query(
        collection(
          db,
          getPatientStatementsCollectionPath(patientId),
        ) as CollectionReference<PatientStatement>,
        where('encounterId', '==', encounterId),
      ),
    [encounterId, patientId],
  )
  const { dataArr: statements } = useQuery<PatientStatement>(ref)

  if (!statements?.length) return null

  return (
    <Box
      border="1px solid"
      borderColor="orange.300"
      bg="orange.50"
      _dark={{ bg: 'orange.900', borderColor: 'orange.600' }}
      borderRadius={6}
      p={3}
      mt={2}>
      <Text
        fontSize="xs"
        fontWeight={700}
        color="orange.800"
        _dark={{ color: 'orange.200' }}
        mb={2}>
        PATIENT WRITTEN STATEMENT
      </Text>
      {statements.map(s => (
        <Box key={s.id} mb={2}>
          <Text fontSize="xs" color="gray.500">
            {new Date(s.submittedAt).toLocaleString()}
          </Text>
          <Text fontSize="sm" whiteSpace="pre-wrap">
            {s.statementText}
          </Text>
        </Box>
      ))}
    </Box>
  )
}
